import * as Toggle from '@radix-ui/react-toggle';
import { Inline } from '../../../../design-system/inline/inline';
import { cn } from '../../../../utils/cn';

type BeneficiaryTypeToggleProps = {
  isPressed: boolean;
  onChange: (isPressed: boolean) => void;
  className?: string;
};

export const BeneficiaryTypeToggle = ({ isPressed, onChange, className }: BeneficiaryTypeToggleProps) => {
  return (
    <div className={cn('w-full overflow-hidden rounded-full bg-white p-1', className)}>
      <Toggle.Root
        pressed={isPressed}
        onPressedChange={onChange}
        aria-label="Toggle between personal and business beneficiary type"
        className="group w-full rounded-full focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden"
      >
        <Inline space={1}>
          <span className="flex-1 rounded-full py-2.5 text-center text-sm font-medium transition-colors group-data-[state=off]:bg-primary group-data-[state=off]:text-black group-data-[state=on]:bg-transparent group-data-[state=on]:text-gray-500 group-data-[state=on]:hover:bg-primary/20">
            Personal
          </span>

          <span className="flex-1 rounded-full py-2.5 text-center text-sm font-medium transition-colors group-data-[state=off]:bg-transparent group-data-[state=off]:text-gray-500 group-data-[state=on]:bg-primary group-data-[state=on]:text-black group-data-[state=off]:hover:bg-primary/20">
            Business
          </span>
        </Inline>
      </Toggle.Root>
    </div>
  );
};
